import { T } from '@tribeplatform/react-components/i18n'

export const EmptyState = () => {
  return (
    <div className="text-sm text-content-subdued text-center">
      <T defaultMessage="No posts to show here" id="Posts.EmptyState" />
    </div>
  )
}
